import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './modules/auth/services/auth.guard';
import { environment } from 'src/environments/environment';
import { NotFoundComponent } from './pages/qube-connect/not-found/not-found.component';

export const routes: Routes = [];

if (environment.isQubeconnect){
  routes.push(
  {
    path: 'not-found',
    component: NotFoundComponent
  },
  {
    path: '**',
    loadChildren: () =>
      import('./modules/connect-mobile/connect-mobile.module').then((m) => m.ConnectMobileModule),
  })
}
else {
  routes.push({
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./modules/errors/errors.module').then((m) => m.ErrorsModule),
  },
  {
    path: 'connect-mobile',
    loadChildren: () =>
      import('./modules/connect-mobile/connect-mobile.module').then((m) => m.ConnectMobileModule),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./_metronic/layout/layout.module').then((m) => m.LayoutModule),
  },
  { path: '**', redirectTo: 'auth' },

  )
}


  // routes.push(
  // {
  //   path: '**',
  //   loadChildren: () =>
  //     import('./modules/connect-mobile/connect-mobile.module').then((m) => m.ConnectMobileModule),
  // })

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
